export default __webpack_public_path__ + "static/FS2S-InHub-158-47045ea5005e3042183d92900e265272.jpg";